module.exports = __webpack_public_path__ + "static/img/20180414165920.7068b3fa.jpg";